// extracted by mini-css-extract-plugin
export var childrenContainer = "_3v-0";
export var virtualScrollArea = "_3v-1";